const endpoints = {
  communications: (id = '') => `communications/${id}`,
  entityMemberships: (id = '') => `entity_memberships/${id}`,
  userSoftwareAccounts: (id = '') => `/user_software_accounts/${id}`,
}

export default endpoints
